import qs from "qs"
import { useRef } from "react"
import { useAppDispatch } from "store"
import styled from "styled-components"
import { setTransaction } from "./paymentSlice"

const StyledIFrame = styled.iframe`
  width: 100%;
  height: 647px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: auto;
    margin: ${(p) => p.theme.spacing(0, -2)};
  }
`

const PaymentFrame = ({ url }: { url: string }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  const dispatch = useAppDispatch()

  const onLoad = () => {
    try {
      // Get the current iframe window
      const iframeWindow = iframeRef.current?.contentWindow

      // If the iframe window does not exist, return
      if (!iframeWindow) return

      // Get the query parameters from the iframe window's location
      const params = qs.parse(iframeWindow?.location?.search, {
        ignoreQueryPrefix: true,
      }) as any

      // Dispatch the action to set the transaction
      dispatch(setTransaction(params))
    } catch (error) {
      //pass
    }
  }

  if (!url) return null

  return (
    <StyledIFrame ref={iframeRef} src={url} frameBorder="0" onLoad={onLoad} />
  )
}

export default PaymentFrame
